<template>
    <div class="px-4 pt-1 pb-4 sm:p-6 lg:grid lg:grid-cols-12 lg:gap-x-8">
        <section class="flex justify-between col-span-12 mb-3 w-full p-2 text-2xl -mt-4 border border-blue-900 text-center font-bold tracking-wider text-blue-900 uppercase">
            <span>Customer Aging Report</span>
            <a :href="`/customer-statement/download`" target="_blank" class="flex items-center text-blue-600 cursor-pointer text-base">
                <svg class="w-6 h-6 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path></svg>
                <span class="font-semibold">Print / Export</span>
            </a>
        </section>
        <section class="lg:col-span-6">
            <div class="w-full mb-4 text-blue-900">
                <h1 class="text-2xl font-bold">Valley Co-op Oil Mill .</h1>
                <p class="">PO Box 841</p>
                <p>Lubbock, TX 79408-0841</p>
                <p class="">Phone: 806.747.3434</p>
                <p>Fax: 806.744.3221</p>
            </div>
            <div class="col-span-12 text-gray-700 tracking-wider py-4 font-thin">
                <p class="text-xs mb-1 font-medium uppercase">Customer:</p>
                <p class="font-mono">{{ $page.props.auth.user.name }}</p>
                <p class="font-mono"> --- </p>
                <p class="font-mono"> --- </p>
            </div>
        </section>
        <section class="lg:col-span-6 lg:grid lg:grid-cols-12 lg:gap-4">
            <div class="lg:col-span-6">
                <div class="border border-blue-200">
                    <div class="p-1 bg-blue-200 text-center text-blue-900 text-xs font-medium uppercase">Date</div>
                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ new Date() | niceDate }}</div>
                </div>
            </div>
            <div class="lg:col-span-6">
                <div class="border border-blue-200">
                    <div class="p-1 bg-blue-200 text-center text-blue-900 text-xs font-medium uppercase">Customer Number</div>
                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ statement.username }}</div>
                </div>
            </div>

            <div class="col-span-12 text-blue-900 bg-blue-100 p-4">
                <p class="text-xs mb-1 font-medium uppercase">Remit To:</p>
                <p class="font-bold">Valley Co-op Oil Mill .</p>
                <p class="font-bold">P.O. Box 841</p>
                <p class="font-bold">Lubbock, TX 79408-0841</p>
            </div>
        </section>
        <hr class="col-span-12 my-6" />

        <section class="border border-blue-100 bg-blue-100 gap-0.5 col-span-12 grid grid-cols-12 mt-6">
            <div class="bg-white col-span-2">
                <div class="p-1 bg-gray-100 text-center text-blue-900 text-xs font-medium uppercase">&lt; 30 Days</div>
                <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ statement.thirty | currency }}</div>
            </div>
            <div class="bg-white col-span-2">
                <div class="p-1 bg-gray-100 text-center text-blue-900 text-xs font-medium uppercase">30 - 60 Days</div>
                <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ statement.sixty | currency }}</div>
            </div>
            <div class="bg-white col-span-2">
                <div class="p-1 bg-gray-100 text-center text-blue-900 text-xs font-medium uppercase">60 - 90 Days</div>
                <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ statement.ninety | currency }}</div>
            </div>
            <div class="bg-white col-span-2">
                <div class="p-1 bg-gray-100 text-center text-blue-900 text-xs font-medium uppercase">90 - 120 Days</div>
                <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ statement.onetwenty | currency }}</div>
            </div>
            <div class="bg-white col-span-2">
                <div class="p-1 bg-gray-100 text-center text-blue-900 text-xs font-medium uppercase">120+ Days</div>
                <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ statement.onetwentyplus | currency }}</div>
            </div>
            <div class="bg-white col-span-2">
                <div class="p-1 bg-blue-100 text-center text-blue-900 text-xs font-bold uppercase">Total</div>
                <div class="p-2 text-right text-gray-700 text-sm font-bold font-mono">{{ statement.total | currency }}</div>
            </div>
        </section>
        <h1 class="col-span-12 text-3xl text-blue-900 font-bold text-center mt-16">Thank You for Your Patronage!</h1>
    </div>
</template>

<script>

export default {
    props: {
        statement: {
            type: Object,
            default: {}
        },
    },
}
</script>
